import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from './dropdown.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';



@NgModule({
  declarations: [
    DropdownComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    DropdownComponent,
  ]
})
export class DropdownModule { }
